import { cn } from "@/lib/utils";

const RelatedArticlesSkeleton: React.FC = () => {
  return (
    <aside className="flex h-fit flex-col gap-2">
      <h3 className="font-montserrat text-subheading-3-500 text-neutral-500 lg:text-subheading-2">
        Related Articles
      </h3>
      <ul
        className="grid grid-cols-1 gap-6"
        aria-label="Loading related articles"
      >
        {[...Array(6)].map((_, index) => (
          <li
            key={index}
            className={cn("animate-pulse", index > 1 && "hidden lg:block")}
          >
            <div className="grid grid-cols-1 gap-2 bg-white">
              <div className="h-6 w-full rounded bg-gray-200"></div>
              <div className="h-6 w-1/3 rounded bg-gray-200"></div>
              <div className="h-4 w-full rounded bg-gray-200"></div>
              <div className="h-4 w-full rounded bg-gray-200"></div>
              <div className="h-4 w-full rounded bg-gray-200"></div>
              <div className="flex justify-between">
                <div className="h-4 w-1/4 rounded bg-gray-200"></div>
                <div className="h-4 w-1/4 rounded bg-gray-200"></div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default RelatedArticlesSkeleton;
